module.exports = __webpack_public_path__ + "img/lbl-01.9cd07692.png";